export default __webpack_public_path__ + "static/media/high proten.9311cb8a.jpg";